import themedark from './themedark';
import themelight from './themelight';

const themes = {
  themedark,
  themelight,
};
export default themes;
